import { Radio } from 'semantic-ui-react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  word-wrap: break-word;
`;

export const QuestionLabel = styled.p`
margin-bottom: 10px;
`;

export const Ranges = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 25px;
  padding-right: 25px;

  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 14px;
      margin-top: 5px;
    }
  }
`;

export const RangeRadioContainer = styled.div`
  cursor: pointer;
  padding: 4px 0;
  align-items: center;
`;

export const RangeRadio = styled(Radio)`
`;

export const Difficulty = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

export const Label = styled.span`
  font-size: 12px;
`;

export const Instructions = styled.div`
  margin-top: 18px;
`;
